import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getUser, updateUser } from "../../services/userService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";

class UserEditForm extends Form {
  state = {
    data: {
      name: "",
      email: "",
      password: "",
    },
    errors: {},
  };

  schema = {
    name: Joi.string().required().label("Name"),
    email: Joi.string().required().label("Email"),
    password: Joi.string().label("Email"),
  };

  async populateUser() {
    try {
      const userId = this.props.match.params.id;
      this.setState({ blocking: true });
      const { data: user } = await getUser(userId);

      this.setState({ blocking: false });
      this.setState({ data: this.mapToViewModel(user) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateUser();
  }

  mapToViewModel(user) {
    return {
      name: user.user.name,
      email: user.user.email,
    };
  }

  doSubmit = async () => {
    try {
      const userId = this.props.match.params.id;

      const data = { ...this.state.data };
      data.id = parseInt(userId);
      this.setState({ blocking: true });
      await updateUser(data);
      this.setState({ blocking: false });
      toast.success("User has been updated successfully.");
      this.props.history.push("/users");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        if (ex.response.data.errors.email)
          errors.email = ex.response.data.errors.email;

        // if (ex.response.data.errors.password)
        //   errors.password = ex.response.data.errors.password;

        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/users.png";
    if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
      return "Your are authorized to perform this action.";
    }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Update user</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/users")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Update user</h3>
              <p>Provide the information below to update the user.</p>
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("email", "Email", "text")}
              {this.renderInput("password", "Password", "password")}

              {this.renderButton("Update")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default UserEditForm;
